import { render, staticRenderFns } from "./ClientInvoices.vue?vue&type=template&id=053b3fce&scoped=true&"
import script from "./ClientInvoices.vue?vue&type=script&lang=js&"
export * from "./ClientInvoices.vue?vue&type=script&lang=js&"
import style0 from "./ClientInvoices.vue?vue&type=style&index=0&id=053b3fce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053b3fce",
  null
  
)

export default component.exports